import React from 'react';
import { colors, typography, radius, spacing } from '../../../theme';

const Stat = ({ value, label, color }) => (
  <div
    style={{
      padding: spacing.lg,
      background: colors.surface1,
      border: `1px solid ${colors.border}`,
      borderRadius: radius.card,
    }}
  >
    <div style={{ ...typography.sectionHeading, color: color || colors.text }}>
      {value}
    </div>
    <div style={{ ...typography.label, color: colors.textMuted, marginTop: '4px' }}>
      {label}
    </div>
  </div>
);

/**
 * Lifetime Summary — compact 2x2 grid.
 * props.stats: { totalWorkouts, totalVolume, totalSets, currentStreak }
 */
const LifetimeSummary = ({ stats }) => {
  if (!stats) return null;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: spacing.md,
        marginBottom: spacing.lg,
      }}
    >
      <Stat value={stats.totalWorkouts || 0} label="WORKOUTS" />
      <Stat value={(stats.totalVolume || 0).toLocaleString()} label="KG LIFTED" color={colors.success} />
      <Stat value={stats.totalSets || 0} label="SETS COMPLETED" />
      <Stat
        value={stats.currentStreak || 0}
        label="WEEK STREAK"
        color={stats.currentStreak > 0 ? colors.gold : colors.text}
      />
    </div>
  );
};

export default LifetimeSummary;
